import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Column, Columns, Container, TextInput } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { getText } from '../../../internal/TextLabels'
import DatePicker from '../../../internal/Datepicker/Datepicker'

const PaymentMethodListItem = ({
  paymentMethod,
  edit,
  disableArrowUp,
  disableArrowDown,
  ...props
}) => {
  const changeValue = (value, field) => {
    props.changeValue(paymentMethod.id, field, value)
  }

  const changeOrder = increase => {
    props.changeOrder(paymentMethod.id, increase)
  }

  return (
    <div
      style={{
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderTop: 0,
        paddingLeft: '1rem',
      }}
    >
      <Container>
        <Columns>
          <Column col3>
            <div
              title={paymentMethod.description}
              style={{
                lineHeight: '5rem',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {paymentMethod.description}
            </div>
          </Column>
          <Column col5 noPadding>
            <Container>
              <Columns>
                <Column col5>
                  <DatePicker
                    name="valid-from"
                    selected={moment(paymentMethod.validFrom)}
                    disabled={!edit}
                    minDate={
                      paymentMethod.paymentMethodValidFrom
                        ? moment(paymentMethod.paymentMethodValidFrom)
                        : null
                    }
                    maxDate={
                      paymentMethod.paymentMethodValidTo
                        ? moment.min(
                            moment(paymentMethod.validTo),
                            moment(paymentMethod.paymentMethodValidTo),
                          )
                        : moment(paymentMethod.validTo)
                    }
                    onChange={date =>
                      changeValue(
                        moment(date).format('YYYY-MM-DD'),
                        'validFrom',
                      )
                    }
                  />
                </Column>
                <Column col1>
                  <div style={{ lineHeight: '5rem' }}>-</div>
                </Column>
                <Column col5>
                  <DatePicker
                    name="valid-to"
                    selected={moment(paymentMethod.validTo)}
                    disabled={!edit}
                    minDate={
                      paymentMethod.paymentMethodValidFrom
                        ? moment.max(
                            moment(paymentMethod.validFrom),
                            moment(paymentMethod.paymentMethodValidFrom),
                          )
                        : moment(paymentMethod.validFrom)
                    }
                    maxDate={
                      paymentMethod.paymentMethodValidTo
                        ? moment(paymentMethod.paymentMethodValidTo)
                        : null
                    }
                    onChange={date =>
                      changeValue(moment(date).format('YYYY-MM-DD'), 'validTo')
                    }
                  />
                </Column>
              </Columns>
            </Container>
          </Column>
          <Column col2>
            <div disabled={!edit} style={{ lineHeight: '5rem' }}>
              {paymentMethod.allowRepresentativeToSetFee ? (
                <TextInput
                  id="fee"
                  type="number"
                  skipValidation
                  disabled={!edit}
                  value={paymentMethod.fee || ''}
                  onChange={e => changeValue(e.target.value, 'fee')}
                />
              ) : (
                getText('paymentSettings.paymentMethods.n/a')
              )}
            </div>
          </Column>
          <Column col1>
            <p
              disabled={!edit || disableArrowUp}
              style={{ textAlign: 'center', cursor: 'pointer' }}
            >
              <span
                className={[midas.icon, midas.midasArrow33].join(' ')}
                aria-hidden="true"
                onClick={() => changeOrder(true)}
              />
            </p>
          </Column>
          <Column col1>
            <p
              disabled={!edit || disableArrowDown}
              style={{ textAlign: 'center', cursor: 'pointer' }}
            >
              <span
                className={[midas.icon, midas.midasArrow34].join(' ')}
                aria-hidden="true"
                onClick={() => changeOrder(false)}
              />
            </p>
          </Column>
        </Columns>
      </Container>
    </div>
  )
}

PaymentMethodListItem.propTypes = {
  paymentMethod: PropTypes.object.isRequired,
  disableArrowUp: PropTypes.bool.isRequired,
  disableArrowDown: PropTypes.bool.isRequired,
  edit: PropTypes.bool.isRequired,
  changeOrder: PropTypes.func.isRequired,
  changeValue: PropTypes.func.isRequired,
}

export default PaymentMethodListItem
